module.exports = __webpack_public_path__ + "media/fart-06.6687767c.mp3";